import { useQuery } from '@tanstack/react-query';

import { getProjectSubcontractSelectOptionById } from './projectSubcontracts';
import { TypesenseCollection } from '../types';
import { useGetTypeSenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';

const PROJECT_SUBCONTRACTS_OPTION_KEY = 'projectSubcontractOption';
export const useGetProjectSubcontractOptionById = (
  id: number | string | undefined,
) => {
  const _id = id && typeof id === 'string' ? id : (id?.toString() ?? undefined);

  const { data: apiKeys } = useGetTypeSenseAPIKeys();
  const collectionApiKey =
    apiKeys?.[TypesenseCollection.PROJECT_SUBCONTRACTS.keyName]?.key ?? null;

  const { data, ...restProps } = useQuery({
    queryKey: [PROJECT_SUBCONTRACTS_OPTION_KEY, _id, collectionApiKey],
    queryFn: () =>
      getProjectSubcontractSelectOptionById(_id!, collectionApiKey!),
    enabled: !!_id && !!collectionApiKey,
  });

  return { data, ...restProps };
};
